module.exports = __webpack_public_path__ + "media/images/ringrevenue/icon_tick-c9b528b9541e127967eda62f79118ef0.png";